/** Demo payloads when REACT_APP_ADMIN_DEMO_MODE=true or API is unavailable. */

export const DEMO_STAFF_PROFILE = {
  id: 1,
  email: "grace@smartsetter.io",
  name: "Demo Admin",
  is_staff: true,
  is_superuser: true,
  can_approve_inbox_templates: true,
}

export const DEMO_TOKEN = "demo-admin-token-local"

export const DEMO_DASHBOARD = {
  active_concierges: 24,
  active_assignments: 67,
  calling_numbers: 41,
  connected_mailboxes: 19,
  activity_reports_30d: {
    report_date_from: "2026-08-19",
    report_date_to: "2026-09-17",
    report_timezone: "America/New_York",
    reports_sent: 48,
    reports_pending: 5,
    reports_failed: 3,
  },
  activity_30d: { calls: 1284, sms: 3421, emails: 892 },
  top_concierges: [
    {
      concierge_user_id: 101,
      email: "sarah.concierge@onebasecrm.com",
      name: "Sarah Chen",
      activity_count: 412,
    },
    {
      concierge_user_id: 102,
      email: "mike.concierge@onebasecrm.com",
      name: "Mike Torres",
      activity_count: 389,
    },
    {
      concierge_user_id: 103,
      email: "jess.concierge@onebasecrm.com",
      name: "Jess Rivera",
      activity_count: 356,
    },
    {
      concierge_user_id: 104,
      email: "alex.concierge@onebasecrm.com",
      name: "Alex Kim",
      activity_count: 301,
    },
    {
      concierge_user_id: 105,
      email: "taylor.concierge@onebasecrm.com",
      name: "Taylor Brooks",
      activity_count: 278,
    },
    {
      concierge_user_id: 106,
      email: "riley.concierge@onebasecrm.com",
      name: "Riley Morgan",
      activity_count: 245,
    },
    {
      concierge_user_id: 107,
      email: "casey.concierge@onebasecrm.com",
      name: "Casey Lee",
      activity_count: 221,
    },
    {
      concierge_user_id: 108,
      email: "jamie.concierge@onebasecrm.com",
      name: "Jamie Patel",
      activity_count: 198,
    },
    {
      concierge_user_id: 109,
      email: "drew.concierge@onebasecrm.com",
      name: "Drew Wilson",
      activity_count: 176,
    },
    {
      concierge_user_id: 110,
      email: "sam.concierge@onebasecrm.com",
      name: "Sam Nguyen",
      activity_count: 154,
    },
  ],
  recent_logs: [
    {
      id: 9001,
      event_type: "login",
      concierge_user_id: 101,
      concierge_email: "sarah.concierge@onebasecrm.com",
      concierge_name: "Sarah Chen",
      account_owner_email: null,
      created: "2026-07-22T10:15:00Z",
    },
    {
      id: 9002,
      event_type: "account_switch",
      concierge_user_id: 102,
      concierge_email: "mike.concierge@onebasecrm.com",
      concierge_name: "Mike Torres",
      account_owner_email: "broker@acme.com",
      created: "2026-07-22T10:12:00Z",
    },
    {
      id: 9003,
      event_type: "calling_number_assigned",
      concierge_user_id: 103,
      concierge_email: "jess.concierge@onebasecrm.com",
      concierge_name: "Jess Rivera",
      account_owner_email: "owner@northstar.com",
      created: "2026-07-22T09:58:00Z",
    },
    {
      id: 9004,
      event_type: "assignment_created",
      concierge_user_id: 104,
      concierge_email: "alex.concierge@onebasecrm.com",
      concierge_name: "Alex Kim",
      account_owner_email: "team@luxehomes.com",
      created: "2026-07-22T09:40:00Z",
    },
    {
      id: 9005,
      event_type: "logout",
      concierge_user_id: 105,
      concierge_email: "taylor.concierge@onebasecrm.com",
      concierge_name: "Taylor Brooks",
      account_owner_email: null,
      created: "2026-07-22T09:22:00Z",
    },
  ],
}

function demoConciergeLoginLink(userId) {
  const apiRoot = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "")
  return `${apiRoot}/clients/concierge-magic-login/demo-${userId}/`
}

export const DEMO_USERS = [
  {
    id: 101,
    email: "sarah.concierge@onebasecrm.com",
    name: "Sarah Chen",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 8,
    login_link: demoConciergeLoginLink(101),
  },
  {
    id: 102,
    email: "mike.concierge@onebasecrm.com",
    name: "Mike Torres",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 6,
    login_link: demoConciergeLoginLink(102),
  },
  {
    id: 103,
    email: "jess.concierge@onebasecrm.com",
    name: "Jess Rivera",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 5,
    login_link: demoConciergeLoginLink(103),
  },
  {
    id: 104,
    email: "alex.concierge@onebasecrm.com",
    name: "Alex Kim",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 4,
    login_link: demoConciergeLoginLink(104),
  },
  {
    id: 105,
    email: "taylor.concierge@onebasecrm.com",
    name: "Taylor Brooks",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 3,
    login_link: demoConciergeLoginLink(105),
  },
  {
    id: 107,
    email: "casey.concierge@onebasecrm.com",
    name: "Casey Lee",
    is_concierge: true,
    is_onebase_staff: true,
    is_active: true,
    active_assignment_count: 2,
    login_link: demoConciergeLoginLink(107),
  },
  {
    id: 201,
    email: "broker@acme.com",
    name: "Acme Brokerage",
    is_concierge: false,
    is_onebase_staff: false,
    is_active: true,
    active_assignment_count: 0,
  },
  {
    id: 202,
    email: "owner@northstar.com",
    name: "North Star Realty",
    is_concierge: false,
    is_onebase_staff: false,
    is_active: true,
    active_assignment_count: 0,
  },
  {
    id: 203,
    email: "team@luxehomes.com",
    name: "Luxe Homes Team",
    is_concierge: false,
    is_onebase_staff: false,
    is_active: true,
    active_assignment_count: 0,
  },
]

export const DEMO_MLS_PURCHASES = [
  {
    id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    user_id: 201,
    user_email: "broker@acme.com",
    status: "paid",
    assignment_status: "pending",
    quantity: 1,
    is_credential_order: true,
    mls_summary: ["Austin Board MLS"],
    contact_details: {
      first_name: "Jane",
      last_name: "Broker",
      office_name: "Acme Realty",
      office_address: "1 Main St",
      city: "Austin",
      state_code: "TX",
    },
    lines: [
      {
        mls_name_snapshot: "Austin Board MLS",
        mls_login_id: "ABOR-100",
        mls_web_address: "https://matrix.example.com",
        username: "jbroker",
        password: "demo-only-secret",
      },
    ],
    paid_at: "2026-09-28T10:00:00Z",
    error_message: "MLS credentials received; manual setup is in progress.",
    created: "2026-09-28T09:55:00Z",
  },
]

export const DEMO_TRIAL_MANAGEMENT = [
  {
    id: 701,
    email: "broker@acme.com",
    user_id: 201,
    current_term_ends_at: "2026-09-15",
    expires_at: "2026-10-15",
    free_candidates_remaining: 42,
    status: "trial",
  },
  {
    id: 702,
    email: "owner@northstar.com",
    user_id: 202,
    current_term_ends_at: "2026-08-20",
    expires_at: "2026-09-20",
    free_candidates_remaining: 18,
    status: "trial_expired",
  },
  {
    id: 703,
    email: "team@luxehomes.com",
    user_id: 203,
    current_term_ends_at: "2026-11-01",
    expires_at: "2026-12-01",
    free_candidates_remaining: 50,
    status: "live",
  },
]

export const DEMO_ASSIGNMENTS = [
  {
    id: 501,
    status: "active",
    concierge_user_id: 101,
    concierge_email: "sarah.concierge@onebasecrm.com",
    concierge_name: "Sarah Chen",
    owner_user_id: 201,
    owner_email: "broker@acme.com",
    owner_name: "Acme Brokerage",
    twilio_voice_phone: "+14155550101",
    zoho_mailbox_email: "sarah.acme@onebasecrm.com",
    created: "2026-06-01T12:00:00Z",
  },
  {
    id: 502,
    status: "active",
    concierge_user_id: 102,
    concierge_email: "mike.concierge@onebasecrm.com",
    concierge_name: "Mike Torres",
    owner_user_id: 202,
    owner_email: "owner@northstar.com",
    owner_name: "North Star Realty",
    twilio_voice_phone: "+14155550102",
    zoho_mailbox_email: "mike.northstar@onebasecrm.com",
    created: "2026-06-15T09:30:00Z",
  },
  {
    id: 503,
    status: "inactive",
    concierge_user_id: 101,
    concierge_email: "sarah.concierge@onebasecrm.com",
    concierge_name: "Sarah Chen",
    owner_user_id: 203,
    owner_email: "team@luxehomes.com",
    owner_name: "Luxe Homes Team",
    twilio_voice_phone: null,
    zoho_mailbox_email: null,
    created: "2026-05-20T14:00:00Z",
  },
]

export const DEMO_AUDIT_LOGS = DEMO_DASHBOARD.recent_logs.concat([
  {
    id: 9006,
    event_type: "access_denied",
    concierge_user_id: 107,
    concierge_email: "casey.concierge@onebasecrm.com",
    concierge_name: "Casey Lee",
    account_owner_email: "broker@acme.com",
    created: "2026-07-22T08:55:00Z",
  },
  {
    id: 9007,
    event_type: "assignment_deactivated",
    concierge_user_id: 103,
    concierge_email: "jess.concierge@onebasecrm.com",
    concierge_name: "Jess Rivera",
    account_owner_email: "team@luxehomes.com",
    created: "2026-07-21T17:30:00Z",
  },
])

export const DEMO_CALLING_NUMBERS = [
  {
    id: 701,
    concierge_user_id: 101,
    concierge_email: "sarah.concierge@onebasecrm.com",
    concierge_name: "Sarah Chen",
    owner_user_id: 201,
    owner_email: "broker@acme.com",
    owner_name: "Acme Brokerage",
    twilio_voice_phone: "+14155550101",
    has_greeting: true,
    created: "2026-06-01T12:00:00Z",
  },
  {
    id: 702,
    concierge_user_id: 102,
    concierge_email: "mike.concierge@onebasecrm.com",
    concierge_name: "Mike Torres",
    owner_user_id: 202,
    owner_email: "owner@northstar.com",
    owner_name: "North Star Realty",
    twilio_voice_phone: "+14155550102",
    has_greeting: false,
    created: "2026-06-15T09:30:00Z",
  },
]

export const DEMO_MAILBOXES = [
  {
    id: 801,
    email: "sarah.acme@onebasecrm.com",
    display_name: "Sarah Chen",
    status: "active",
    oauth_status: "connected",
    assigned_user_id: 101,
    assigned_user_email: "sarah.concierge@onebasecrm.com",
    assigned_user_name: "Sarah Chen",
    owner_user_id: 201,
    owner_user_email: "broker@acme.com",
    owner_user_name: "Acme Brokerage",
  },
  {
    id: 802,
    email: "mike.northstar@onebasecrm.com",
    display_name: "Mike Torres",
    status: "active",
    oauth_status: "connected",
    assigned_user_id: 102,
    assigned_user_email: "mike.concierge@onebasecrm.com",
    assigned_user_name: "Mike Torres",
    owner_user_id: 202,
    owner_user_email: "owner@northstar.com",
    owner_user_name: "North Star Realty",
  },
]

export const DEMO_CALL_LOGS = [
  {
    id: 601,
    twilio_sid: "CA_demo_001",
    concierge_user_id: 101,
    concierge_email: "sarah.concierge@onebasecrm.com",
    concierge_name: "Sarah Chen",
    candidate_name: "Jane Prospect",
    disposition: "connected",
    recording_status: "completed",
    recording_url: null,
    created: "2026-07-22T09:10:00Z",
  },
  {
    id: 602,
    twilio_sid: "CA_demo_002",
    concierge_user_id: 102,
    concierge_email: "mike.concierge@onebasecrm.com",
    concierge_name: "Mike Torres",
    candidate_name: "John Agent",
    disposition: "voicemail",
    recording_status: "completed",
    recording_url: null,
    created: "2026-07-22T08:45:00Z",
  },
]

export const DEMO_VOICEMAILS = [
  {
    id: 901,
    concierge_user_id: 101,
    concierge_email: "sarah.concierge@onebasecrm.com",
    concierge_name: "Sarah Chen",
    owner_email: "broker@acme.com",
    owner_name: "Acme Brokerage",
    from_phone: "+14155550999",
    did_phone: "+14155550101",
    recording_status: "completed",
    transcription_status: "completed",
    transcript: "Hi, calling back about the listing...",
    created: "2026-07-21T16:20:00Z",
  },
]

export const DEMO_ZOHO_ORG_CONNECTION = {
  id: 1,
  zoid: "123456789",
  domain: "clients.onebasecrm.com",
  data_center: "ca",
  status: "connected",
  connected_at: "2026-05-01T10:00:00Z",
  connected_by_id: 1,
  connected_by_email: "admin@onebasecrm.com",
  connected_by_name: "Demo Admin",
  seats_total: 25,
  seats_used: 19,
  token_expiry: "2026-08-01T10:00:00Z",
  last_error: "",
  created: "2026-05-01T10:00:00Z",
  modified: "2026-07-20T12:00:00Z",
}

export const DEMO_ZOHO_MAILBOX_AUDIT_LOGS = [
  {
    id: 1001,
    action: "connect",
    mailbox_id: 801,
    mailbox_email: "sarah@clients.onebasecrm.com",
    actor_id: 1,
    actor_email: "admin@onebasecrm.com",
    actor_name: "Demo Admin",
    success: true,
    error_code: "",
    metadata: {},
    created: "2026-07-22T11:00:00Z",
  },
  {
    id: 1002,
    action: "sync",
    mailbox_id: 802,
    mailbox_email: "mike@clients.onebasecrm.com",
    actor_id: 102,
    actor_email: "mike.concierge@onebasecrm.com",
    actor_name: "Mike Torres",
    success: true,
    error_code: "",
    metadata: { messages: 12 },
    created: "2026-07-21T09:30:00Z",
  },
  {
    id: 1003,
    action: "error",
    mailbox_id: 801,
    mailbox_email: "sarah@clients.onebasecrm.com",
    actor_id: 101,
    actor_email: "sarah.concierge@onebasecrm.com",
    actor_name: "Sarah Chen",
    success: false,
    error_code: "oauth_expired",
    metadata: {},
    created: "2026-07-20T16:45:00Z",
  },
]

export const DEMO_INBOX_TEMPLATES = [
  {
    id: 1,
    name: "Default welcome",
    subject: "Thanks for getting in touch",
    html_body:
      "<p>Hi {{ first_name }}, thanks for writing in. A concierge will follow up shortly.</p>",
    created: "2026-07-21T09:00:00Z",
    attachments: [],
    attachment_count: 0,
    is_global: true,
    approval_status: "approved",
    ai_generated: false,
    ai_prompt: "",
    approved_at: "2026-07-21T09:05:00Z",
    approved_by_email: "grace@smartsetter.io",
  },
  {
    id: 2,
    name: "Default follow-up",
    subject: "Checking in",
    html_body:
      "<p>Just checking in to see if you still need help with recruiting.</p>",
    created: "2026-07-18T14:20:00Z",
    attachments: [],
    attachment_count: 1,
    is_global: true,
    approval_status: "approved",
    ai_generated: false,
    ai_prompt: "",
    approved_at: "2026-07-18T14:25:00Z",
    approved_by_email: "grace@smartsetter.io",
  },
]

export const DEMO_CONCIERGE_INBOX_TEMPLATES = [
  {
    id: 101,
    name: "Concierge follow-up",
    subject: "Following up",
    created: "2026-09-08T10:30:00Z",
    attachment_count: 0,
    approval_status: "pending",
    approved_at: null,
    approved_by_email: null,
    parent_user_id: 201,
    parent_name: "Acme Realty",
    parent_email: "owner@acmerealty.com",
  },
  {
    id: 102,
    name: "Viewing confirmation",
    subject: "Your viewing is confirmed",
    created: "2026-09-07T15:00:00Z",
    attachment_count: 0,
    approval_status: "approved",
    approved_at: "2026-09-07T15:15:00Z",
    approved_by_email: "owner@example.com",
    parent_user_id: 202,
    parent_name: "North Star Realty",
    parent_email: "owner@example.com",
  },
]

export const DEMO_CONCIERGE_INBOX_SMS_TEMPLATES = [
  {
    id: 201,
    name: "Concierge SMS follow-up",
    text: "Hi {{ first_name }}, just checking in.",
    created: "2026-09-08T10:30:00Z",
    approval_status: "pending",
    approved_at: null,
    approved_by_email: null,
    parent_user_id: 201,
    parent_name: "Acme Realty",
    parent_email: "owner@acmerealty.com",
  },
]

export const DEMO_INBOX_SMS_TEMPLATES = [
  {
    id: 1,
    name: "Default SMS welcome",
    text: "Hi {{ first_name }}, thanks for texting. A concierge will follow up shortly.",
    created: "2026-07-21T09:00:00Z",
    is_global: true,
    approval_status: "approved",
    ai_generated: false,
    ai_prompt: "",
    approved_at: "2026-07-21T09:05:00Z",
    approved_by_email: "grace@smartsetter.io",
  },
  {
    id: 2,
    name: "Default SMS follow-up",
    text: "Just checking in to see if you still need help with recruiting.",
    created: "2026-07-18T14:20:00Z",
    is_global: true,
    approval_status: "approved",
    ai_generated: false,
    ai_prompt: "",
    approved_at: "2026-07-18T14:25:00Z",
    approved_by_email: "grace@smartsetter.io",
  },
]

export function isAdminDemoMode() {
  return process.env.REACT_APP_ADMIN_DEMO_MODE === "true"
}
